<template>
  <div class="container" v-wechat-title="$route.meta.title">
    
    <!-- 销售报表 -->
    <div class="onePart">
      <div v-if="changeIndex == 0" v-bind:class="{ day:changeIndex== 0,'date-bar':1}">{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'m')}} <span @click="selectDate('add')">&gt;&gt;</span></div>
      <div v-if="changeIndex == 1" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'d')}} - {{showDate(endDay,'d')}} <span @click="selectDate('add')">&gt;&gt;</span></div>

      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>
        <div @click="changeType" :index="1" :class="[changeIndex==1?'div1':'div2']">周报</div>
        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <div v-if="changeIndex == 0" class="info info2 disp-just-aro-ali-cen-fldir-col">
 
          <div v-if="changeIndex == 0" class="div-relative">今日营业额（元）<p @click="checkQues('今日营业额_'+(changeIndex+1))" class="ques"></p></div>
                    <div v-else >营业额（元）</div>

          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("营业额",0)}}</div>
          <div>昨日营业额：<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日营业额",0)}}</div>
        </div>
        <div v-if="changeIndex == 0" class="info info2 disp-just-aro-ali-cen-fldir-col">
 
          <div v-if="changeIndex == 0" class="div-relative">今日毛利（元）<p @click="checkQues('今日毛利_'+(changeIndex+1))" class="ques"></p></div>
                    <div v-else >毛利（元）</div>
          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("销售总毛利",0)}}</div>
          <div>昨日毛利：<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日销售总毛利",0)}}</div>
        </div>
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
      
           <div v-if="changeIndex == 0" class="div-relative">今日客单价（元）<p @click="checkQues('今日客单价_'+(changeIndex+1))" class="ques"></p></div>
           <div v-else class="div-relative">客单价（元）<p @click="checkQues('客单价_'+(changeIndex+1))" class="ques"></p></div>

          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("客单价",0)}}</div>
          <div v-if="changeIndex == 0">昨日客单价：<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日客单价",0)}}</div>
          <div v-if="changeIndex != 0"></div>
        </div>
          <div class="info info2 disp-just-aro-ali-cen-fldir-col">
           <div v-if="changeIndex == 0" class="div-relative">今日销售成本（元）<p @click="checkQues('今日销售成本_'+(changeIndex+1))" class="ques"></p></div>
                    <div v-else  class="div-relative">销售成本（元）<p @click="checkQues('销售成本_'+(changeIndex+1))" class="ques"></p></div>

          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("销售成本",0)}}</div>
          <div v-if="changeIndex == 0">昨日销售成本：<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日销售成本",0)}}</div>
          <div v-if="changeIndex != 0"></div>
        </div>
        <div v-if="changeIndex == 0" class="info info_1 info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">会员卡总销售额（元）<p @click="checkQues('会员卡总销售额_'+(changeIndex+1))" class="ques"></p></div>
          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("会员卡总销售额",0)}}</div>
          <div>昨日会员卡总销售额：<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日会员卡总销售额",0)}}</div>
        </div>
      
      </div>
    </div>

    <!-- 单日营业额 -->
    <div class="onePart" :style="changeIndex != 0?'':'display:none;' ">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        营业额趋势（元）<p @click="checkQues('营业额趋势_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barTurnoverByDay" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 单日毛利 -->
    <div :style="changeIndex != 0?'':'display:none;' " class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        毛利趋势（元）<p @click="checkQues('毛利趋势_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barProfitByDay" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- 单日会员卡总销售额 -->
    <div :style="changeIndex != 0?'':'display:none;' " class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡总销售额（元）<p @click="checkQues('单日会员卡总销售额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barCustCardByDay" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>


   <!-- 消费客户构成 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        消费客户构成<p @click="checkQues('消费客户构成_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 商品销量 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        商品销量（件）<p @click="checkQues('商品销量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 商品销售额 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative"> 
        商品销售额（元）<p @click="checkQues('商品销售额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
     <!-- 销售毛利品类分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative"> 
        销售毛利品类分布（元）<p @click="checkQues('销售毛利品类分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barThree" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- 会员卡销量 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        会员卡销量（张）<p @click="checkQues('会员卡销量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barFour" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 会员卡销售额 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        会员卡销售额（元）<p @click="checkQues('会员卡销售额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barFive" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- 会员卡消费营业额 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        会员卡消费营业额（元）<p @click="checkQues('会员卡消费营业额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barCardUsedAmt" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>



    <!-- 单日会员卡销售数量 -->
    <div v-if="changeIndex != 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡销售数量（张）<p @click="checkQues('会员卡销量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getCardNumByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table">
            <tr v-for="(item,i) in getCardNumByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
      
    </div>

    <!-- 单日会员卡销售金额 -->
    <div v-if="changeIndex != 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡销售金额（元）<p @click="checkQues('单日会员卡销售金额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getCardAmtByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table">
            <tr v-for="(item,i) in getCardAmtByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>  
    </div>


    <!-- 单日会员卡消费的营业额 -->
    <div v-if="changeIndex != 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡消费的营业额（元）<p @click="checkQues('会员卡消费营业额_'+(changeIndex+1))" class="ques2"></p>
      </div>

      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getCardOrderAmtByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table">
            <tr v-for="(item,i) in getCardOrderAmtByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  
    
    <!-- 单日会员卡退卡数量 -->
    <div v-if="changeIndex != 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡退卡数量（张）<p @click="checkQues('会员退卡数量_'+(changeIndex+1))" class="ques2"></p>
      </div>

      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getReturnCardNumByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table">
            <tr v-for="(item,i) in getReturnCardNumByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div> 
    </div>
    <!-- 单日会员卡退卡金额 -->
    <div v-if="changeIndex != 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日会员卡退卡金额（元）<p @click="checkQues('会员卡退卡金额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getReturnCardAmtByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table">
            <tr v-for="(item,i) in getReturnCardAmtByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>

    </div>

  <!-- 会员退卡数量 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        会员退卡数量（张）<p @click="checkQues('会员退卡数量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barReturnCardNum" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 会员退卡金额 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        会员退卡金额（元）<p @click="checkQues('会员退卡金额_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barReturnCardAmt" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

   <div class="divPlaceholder">&nbsp;</div>
    <!-- loading的显示隐藏 -->
    <!-- <van-popup :close-on-click-overlay="false" v-model="loadShow">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </van-popup> -->
    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
  </div>
 
</template>
<script>
  import Vue from 'vue'
  import util from '../../static/js/util'
  import {
    Toast, 
  } from 'vant';
  Vue.use(Toast);
  import baseUrl from '../../static/js/basedata.js'
  import {
    Loading
  } from 'vant';
  Vue.use(Loading);

  export default {
    name: 'InfoPage',
    data() {
      return {
        
        changeIndex: 0,
        beginDay: new Date(),
        endDay: new Date(),
        RptData: {},
        loadShow: false,
        show: false,
        minDate: new Date(),
        maxDate: new Date(2999, 1, 1),
        showDetail:false,//显示弹框详细数据
        isPopupShow: false,
        keyWord:'',//带入组件关键字
        popupIsShow:false,
        popupShow:false,//底部弹框是否显示
        keyWords:'',
        popupTitle:'弹框标题',//弹框标题
        popupContent:'弹框内容',//弹框标题
      }
    },
    computed: {
      getDate: function() {
        if (this.changeIndex == 0) {
          return this.formatDate(new Date(this.beginDay));
        } else {
          return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(new Date(this.endDay))}`
        }
      },
      getCardNumByDay: function () {
        var para = { X: "会员卡", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日会员卡销售数量", para);
        return rst;
      },
      getCardAmtByDay: function () {
        var para = { X: "会员卡", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日会员卡销售额", para);
        return rst;
      },
      getReturnCardNumByDay: function () {
        var para = { X: "会员卡", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日会员卡退卡数量及金额统计", para);
        return rst;
      },
      getReturnCardAmtByDay: function () {
        var para = { X: "会员卡", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日会员卡退卡数量及金额统计", para,"Other");
        return rst;
      },
      getCardOrderAmtByDay: function () {
        var para = { X: "会员卡", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日会员卡消费的营业额", para);
        return rst;
      }
    },
    methods: {
      checkQues(_key){
        console.log(_key)
        this.isPopupShow = true;
        this.keyWord = _key;
        this.popupIsShow = true;
      },
      childReturn(data){
        console.log('data-----',data)
        this.isPopupShow = data;
        this.popupIsShow = data;
      },
      formatDate(date) {
        // 今日选择
        if(this.changeIndex == 0){
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }else if(this.changeIndex == 1){
          // 周选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }else if(this.changeIndex == 2){
          // 月选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }
      },
      showDate(date, mode) {
        // 今日选择
        mode = mode || 'a';
        date = new Date(date);
        if (this.changeIndex == 0) {
          return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 1) {
           if (mode === 'y') {
          return `${date.getFullYear()}年`;
        }
        if (mode === 'd')
          return `${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 2) {
          // 月选择
          if (mode === 'y') {
            return `${date.getFullYear()}年`;
          }
          if (mode === 'm')
            return `${date.getMonth() + 1}月`;
        }
      },
      selectDate(mode) {
        if (this.changeIndex == 2) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() + 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() - 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
        if (this.changeIndex == 1) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate()+7);            
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() - 7);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
      },
      onConfirm(date) {
        if(this.changeIndex == 0){
          this.beginDay = date.format("yyyy-MM-dd");
          this.endDay = date.format("yyyy-MM-dd");
        }else {
          const [start, end] = date;
          this.beginDay = start.format("yyyy-MM-dd");
          this.endDay = end.format("yyyy-MM-dd");
        } 
        this.loadData();
      },
      changeType(e){
        var index = e.target.getAttribute('index');
        this.changeIndex = Number(index);
        var date =  this.$dateUtil.today();
        switch (this.changeIndex) {
          case 0:
            date = this.$dateUtil.today();
            break;
          case 1:
            date = this.$dateUtil.thisWeek();
            break;
          case 2:
            date = this.$dateUtil.thisMonth();
            break;
        }
        this.beginDay = date.Begin;
        this.endDay = date.End;
        this.loadData();
      },
      loadData() {
        var that = this;
        that.loadShow = true;
        this.show = false;
        var query = {
          ReportType : this.$util.AppReportType.销售报表,
          Begin: this.beginDay,
          End:this.endDay
        };
        this.$api.get("/AppReport", query, function (res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        }, function (err) { that.loadShow = false; });
      },
      getOneDimension(subTypeName,def) {
        return this.$util.getOneDimension(this.RptData.Items, subTypeName, def);
      },
      getTwoDimension(subTypeName, defX, defY) {
        return this.$util.getTwoDimension(this.RptData.Items, subTypeName, defX, defY);
      },
      getTwoDimensionBar(subTypeName, defY, defValue,valueColumn) {
        return this.$util.getTwoDimensionBar(this.RptData.Items, subTypeName, defY, defValue,valueColumn);
      },
      backLast() {
        this.$router.go(-1); //返回上一层
      },
      drawPie() {

  
        if (this.changeIndex != 0) {
            
         var barTurnoverByDayData = this.getTwoDimensionBar("单日营业额", new Date().format("MM-dd"), "0");
          this.$echarts.init(document.getElementById('barTurnoverByDay')).setOption(
            this.$util.LineOption(barTurnoverByDayData, "营业额:"+this.getOneDimension("营业额",0))
          );
          
          var barProfitByDayData = this.getTwoDimensionBar("单日毛利", new Date().format("MM-dd"), "0");
          this.$echarts.init(document.getElementById('barProfitByDay')).setOption(
            this.$util.LineOption(barProfitByDayData,"毛利:"+this.getOneDimension("销售总毛利",0))
          );
         
          var barCustCardByDayData = this.getTwoDimensionBar("单日会员卡总销售额", new Date().format("MM-dd"), "0");
          this.$echarts.init(document.getElementById('barCustCardByDay')).setOption(
            this.$util.LineOption(barCustCardByDayData,"销售额:"+this.getOneDimension("会员卡总销售额",0))
          );
        }
        
 
        var barOneData = this.getTwoDimensionBar("商品销量排行", "商品", "0");
        this.$echarts.init(document.getElementById('barOne')).setOption(
            this.$util.BarOption(barOneData,"销量")
        );

         var barTwoData = this.getTwoDimensionBar("商品销售额排行", "销售额", "0");
         this.$echarts.init(document.getElementById('barTwo')).setOption(
         this.$util.BarOption(barTwoData,"销售额")
        );

        var barThreeData = this.getTwoDimensionBar("销售毛利品类分布", "毛利", "0");
         this.$echarts.init(document.getElementById('barThree')).setOption(
         this.$util.BarOption(barThreeData,"毛利")
        );

        var barFourData = this.getTwoDimensionBar("会员卡销售数量", "会员卡", "0");
        this.$echarts.init(document.getElementById('barFour')).setOption(
          this.$util.BarOption(barFourData,"销量")
        );

        var barFiveData = this.getTwoDimensionBar("会员卡销售额", "会员卡", "0");
        this.$echarts.init(document.getElementById('barFive')).setOption(
         this.$util.BarOption(barFiveData,"销售额")
        );

        var barReturnCardNumData = this.getTwoDimensionBar("会员卡退卡数量及金额统计", "会员卡", "0");
        this.$echarts.init(document.getElementById('barReturnCardNum')).setOption(
          this.$util.BarOption(barReturnCardNumData,"数量")
        );
       var barReturnCardAmtData = this.getTwoDimensionBar("会员卡退卡数量及金额统计", "会员卡", "0","Z");
        this.$echarts.init(document.getElementById('barReturnCardAmt')).setOption(
          this.$util.BarOption(barReturnCardAmtData,"金额")
        );

        var barCardUsedAmtData = this.getTwoDimensionBar("会员卡消费的营业额", "会员卡", "0");
        this.$echarts.init(document.getElementById('barCardUsedAmt')).setOption(
          this.$util.BarOption(barCardUsedAmtData,"营业额")
        );

         var pieOneData = this.getTwoDimension("消费用户构成", "其他", "0");
        this.$echarts.init(document.getElementById('pieOne')).setOption( this.$util.PieOption(pieOneData,"人"));
         
      },
    },

    mounted() {
     
      var date = this.$dateUtil.today();
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
       phoneDevice.setTitle(this.$route.meta.title || "");
    }
  }
</script>

<style>
  @import url("../../static/css/common.css");
  .topChange{
    width: 100%;
    margin-bottom: 0.53rem;
  }
  .topChange .div1{
    width: auto;
    font-size: 0.34rem;
    color: #1C1C1C;
    border-bottom: 0.05rem solid #1699E5;
  }
  .topChange .div2{
    width: auto;
    font-size: 0.34rem;
    color: #999999;
    border-bottom: 0.05rem solid transparent;
  }

  .wrap .info1 {
    background-image: url(../assets/indexImage/img10.png);
  }

  .wrap .info2 {
    background-image: url(../assets/indexImage/img2.png);
  }

  .wrap .info3 {
    background-image: url(../assets/indexImage/img4.png);
  }

  .wrap .info4 {
    background-image: url(../assets/indexImage/img6.png);
  }

  .wrap .info5 {
    background-image: url(../assets/indexImage/img12.png);
  }

  .wrap .info6 {
    background-image: url(../assets/indexImage/img8.png);
  }

  /* .wrap .info div {
    width: 100%;
  }

  .wrap .info div:first-child {
    font-size: 0.32rem;
  }

  .wrap .info div:nth-child(2) {
    font-size: 0.5rem;
    font-weight: bold;
    text-align: center;
  }

  .wrap .info div:nth-child(3) {
    font-size: 0.32rem;
    text-align: right;
  } */
</style>



// WEBPACK FOOTER //
// src/components/xiaoshoubaobiao.vue